// Web build picks this up via rspack's `.web.js` extension preference.
// Autocapture relies on RN-internal Fiber traversal and the Babel
// instrumentor's RN-component pattern matching, neither of which apply to the
// web bundle, so every entry point here is an intentional no-op.
const noop = () => {}
const identity = (component) => component

const Heap = {
  setTracking: noop,
  withReactNavigationAutotrack: identity,
  withHeapTouchableAutocapture: identity,
  withHeapPressableAutocapture: identity,
  withHeapTextInputAutocapture: identity,
  withHeapIgnore: identity,
  autotrackPress: noop,
  autotrackSwitchChange: noop,
  autocaptureScrollView: noop,
  autocaptureTextInput: noop,
  Ignore: ({ children }) => children,
  IgnoreTargetText: ({ children }) => children,
}

export default Heap

export const HeapIgnore = Heap.Ignore
export const HeapIgnoreTargetText = Heap.IgnoreTargetText
